import React from "react";
import { LayoutDashboard, Radar, Map, Calendar, BarChart3, MapPin, TrendingUp, Newspaper, Filter, Network, Globe } from "lucide-react";

const VIEWS = [
  { id: "overview", label: "Overview", icon: LayoutDashboard },
  { id: "map", label: "Geospatial Map", icon: Map },
  { id: "tree", label: "Sentiment Drill-down", icon: Network },
  { id: "feed", label: "Live Post Feed", icon: Newspaper },
  { id: "trends", label: "Trends & Forecasting", icon: TrendingUp },
  { id: "area", label: "Area Report", icon: MapPin },
  { id: "platforms", label: "Platform Mix", icon: Filter },
];

export default function Sidebar({ active, onChange, kpis, collapsed }) {
  return (
    <aside
      className={`shrink-0 h-full border-r border-slate-200 bg-white flex flex-col transition-all duration-300 ease-in-out ${collapsed ? "w-[70px]" : "w-[260px]"}`}
      data-testid="sidebar"
    >
      <div className={`px-5 py-5 border-b border-slate-200 overflow-hidden ${collapsed ? "px-[18px]" : ""}`}>
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="CIMAP Logo" className="h-8 w-auto min-w-[32px]" />
          {!collapsed && (
            <div className="transition-opacity duration-300">
              <div className="font-display text-[15px] font-bold tracking-tight leading-none text-slate-900 whitespace-nowrap">CIMAP</div>
              <div className="text-[9px] uppercase tracking-[0.2em] text-slate-500 mt-1 whitespace-nowrap">Intelligence Console</div>
            </div>
          )}
        </div>
      </div>

      {!collapsed && (
        <div className="px-5 py-4 border-b border-slate-200 transition-opacity duration-300">
          <div className="kicker mb-3">At a glance</div>
          <div className="grid grid-cols-2 gap-3">
            <MiniKPI label="Signals" value={kpis?.total_posts} />
            <MiniKPI label="Critical" value={kpis?.critical_count} tone="critical" />
            <MiniKPI label="Active sites" value={kpis?.active_sites} />
            <MiniKPI label="24h volume" value={kpis?.posts_last_24h} tone="info" />
          </div>
        </div>
      )}

      <div className="flex-1 overflow-x-hidden overflow-y-auto thin-scroll py-2" data-testid="sidebar-nav">
        {!collapsed && <div className="kicker px-5 mb-1">Analysis</div>}
        {VIEWS.map((v) => (
          <button
            key={v.id}
            className={`nav-item w-full text-left flex items-center transition-all ${collapsed ? "px-[26px] justify-center" : "px-5"} ${active === v.id ? "active" : ""}`}
            onClick={() => onChange(v.id)}
            data-testid={`nav-${v.id}`}
            title={collapsed ? v.label : ""}
          >
            <v.icon className={`h-4 w-4 shrink-0 ${active === v.id ? "text-blue-600" : "text-slate-500"}`} />
            {!collapsed && <span className="ml-3 whitespace-nowrap">{v.label}</span>}
          </button>
        ))}
      </div>

      <div className={`px-5 py-3 border-t border-slate-200 text-[10px] uppercase tracking-[0.22em] text-slate-400 overflow-hidden ${collapsed ? "px-[14px] text-center" : ""}`}>
        {collapsed ? "v1" : "v1.0 · Analyst build"}
      </div>
    </aside>
  );
}

function MiniKPI({ label, value, tone = "default" }) {
  const color = { critical: "text-[#dc2626]", info: "text-[#0284c7]", default: "text-slate-900" }[tone];
  return (
    <div className="border border-slate-200 p-2.5">
      <div className="text-[9px] uppercase tracking-[0.16em] text-slate-500">{label}</div>
      <div className={`font-display text-lg font-bold ${color}`}>{value ?? "—"}</div>
    </div>
  );
}
